import { UpNextCalendarEventsLoaderScenarioId } from '../UpNextV2Constants';
import { getUpNextCalendarEventId } from 'owa-upnext-event-loader';

export function isUpNextEventReady(): boolean {
    return !!getUpNextCalendarEventId(UpNextCalendarEventsLoaderScenarioId);
}
